import { ShortenedUrlData } from '@mobi/api-types'
import { get, post } from '@core/Services/ApiService'

export const generateShortenedUrl = async (originalUrl: URL): Promise<URL> => {
  const response = await post<ShortenedUrlData>({
    url: '/api/shorten-url',
    body: { url: originalUrl.toString() },
  })

  return new URL(response.shortenedUrl)
}

export const resolveLongUrl = async (urlKey: string): Promise<URL> => {
  const urlRecord = await get<ShortenedUrlData>({
    url: `/api/url-shortener/url/${urlKey}`,
  })

  return new URL(urlRecord.url)
}
